import React, { useState, useEffect } from 'react';
import '../css/FileUpload.css'; // Import the CSS file
import { uploadPdf } from '../services/api'; // Import the function from your API module

function FileUpload() {
    const [file, setFile] = useState(null);
    const [agentId, setAgentId] = useState('');
    const [language, setLanguage] = useState('english'); // Default language
    const [fundType, setFundType] = useState('mutual'); // Default fund type

    useEffect(() => {
        const storedAgentId = localStorage.getItem("agentId");
        if (storedAgentId) {
            setAgentId(storedAgentId);
        }
    }, []);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleLanguageChange = (e) => {
        setLanguage(e.target.value);
    };

    const handleFundTypeChange = (e) => {
        setFundType(e.target.value);
    };

    const handleFileUpload = async () => {
        if (!file) {
            alert('Please select a file to upload.');
            return;
        }

        if (!agentId) {
            alert('Agent ID not found.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('agentId', agentId);
        formData.append('language', language); // Append language selection
        formData.append('fundType', fundType); // Append fund type selection

        try {
            const response = await uploadPdf(formData); // Use the function from your API module

            if (response.status === 200) {
                alert('File uploaded successfully!');
                if (response.data.includes("PDF successfully generated:")) {
                    alert(response.data);
                }
            }
        } catch (error) {
            alert('File upload failed. Please try again.');
        }
    };

    return (
        
        
        <div className="container">
            <h2>File Upload</h2>
            <div className="language-selection">
                <label>
                    <input
                        type="radio"
                        value="mutual"
                        checked={fundType === 'mutual'}
                        onChange={handleFundTypeChange}
                    />
                    Mutual Fund
                </label>
                <label>
                    <input
                        type="radio"
                        value="non-mutual"
                        checked={fundType === 'non-mutual'}
                        onChange={handleFundTypeChange}
                    />
                    Non Mutual Fund
                </label>
            </div>
            <input type="file" onChange={handleFileChange} />
            <div className="language-selection">
                <label>
                    <input
                        type="radio"
                        value="english"
                        checked={language === 'english'}
                        onChange={handleLanguageChange}
                    />
                    English
                </label>
                <label>
                    <input
                        type="radio"
                        value="hindi"
                        checked={language === 'hindi'}
                        onChange={handleLanguageChange}
                    />
                    Hindi
                </label>
            </div>
            
            <button onClick={handleFileUpload}>Generate Report</button>
        </div>
    );
}

export default FileUpload;